module.exports = __webpack_public_path__ + "img/1.1aa0fa3.jpg";